// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__2y8iO","logo":"Footer_logo__bZHmh","links":"Footer_links__3qjA-","socials":"Footer_socials__O7ovQ","social":"Footer_social__2mW7j"};